import React from "react";
import style from "./Text.module.css";

export default function Text(props) {
  const { text } = props;
  return (
    <div className={style.divTxt}>
      <div className={style.txt}>{text}</div>
    </div>
  );
}
